import useDebounce from "@/common/hooks/useDebounce";
import { Mapper } from "@/common/services/mapper";
import { DashboardFilterProps, DashboardFilters } from "@/features/company/types/dashboards/dashboard.type";
import { useEstablishmentCompanies } from "@/features/companyBranches/hooks/useEstablishmentCompanies";
import { EstablishmentCompanyTransformer } from "@/features/companyBranches/services/establishmentCompanyTransformer";
import DashboardFilterBadge from "../DashboardFilterBadge";

const DashboardFilterEstablishmentBranchBadge = ({ filters, setFilters }: DashboardFilterProps) => {
  const [search, setSearch] = useDebounce('');

  const {
    data: establishmentBranchOptions,
  } = useEstablishmentCompanies({
    filters: {
      search,
    },
    mapper: Mapper.mapWithTransformer({
      transformer: EstablishmentCompanyTransformer.optionTransformer({
        valueFieldName: 'matrix_branch_id',
      }),
    }),
  });

  return (
    <DashboardFilterBadge
      filterKey={DashboardFilters.EstablishmentBranch}
      options={establishmentBranchOptions}
      filters={filters}
      setFilters={setFilters}
      setSearch={setSearch}
    />
  );
}

export default DashboardFilterEstablishmentBranchBadge;
